import { useMutation, useQueryClient } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import {
  apiErrorHandler,
  getBackendErrorMessage,
} from "@/core/api/api-error-handler";
import { invalidateAfterMutation } from "@/core/api/invalidate-after-mutation";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { logger } from "@/core/utils/func/logger";
import { merchantEndpoints } from "@/features/merchant/api/endpoints";

/**
 * Supprime une dérogation tarifaire (`DELETE /MerchantFeeOverrides/{id}`) :
 * le marchand revient au barème standard.
 */
export const useDeleteFeeOverride = (merchantId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["merchant", "fee-overrides", "delete", merchantId],
    mutationFn: (merchantFeeOverrideId: string) =>
      mutateData({
        url: merchantEndpoints.merchantFeeOverrides.remove(
          merchantFeeOverrideId
        ),
        method: "DELETE",
      }),
    onSuccess: () => {
      return invalidateAfterMutation(queryClient, [
        QUERY_KEYS.MERCHANT_FEE_OVERRIDES(merchantId),
      ]);
    },
    onError: (error) => {
      const message = getBackendErrorMessage(error) ?? apiErrorHandler(error);
      logger.error(
        `useDeleteFeeOverride failed: ${message}`,
        error instanceof Error ? error : undefined,
        { prefix: "merchant" }
      );
    },
  });
};
